import React from 'react';
import './Label.scss';

const Label = (props) => {
    return (
        <label
            className = {props.className ? props.className : ''}
            htmlFor = {props.htmlFor ? props.htmlFor : ''}
            {...props}
        >
            {props.value}
        </label>
    );
}

export default Label;
